// import React from 'react';
// import {Link} from 'react-router';
// import {Menu} from 'antd';
// import {layout} from 'icsoc-antd-ex';

// const {BaseContent, BaseContentMain, BaseContentSider} = layout;

// const AI = ({
//   children,
//   location: {pathname = '/systemSetting/workTime'} = {},
// }) => {
//   const defaultSelectedKeys =
//     (pathname === '/ai' ? '/ai/questionStudy' : pathname) ||
//     '/ai/questionStudy';

//   const baseContentSiderRender = (
//     <BaseContentSider
//       title="AI优化"
//       selectedKeys={[defaultSelectedKeys]}
//       mode="inline">
//       <Menu.Item key="/ai/questionStudy">
//         <Link to="/ai/questionStudy">问题学习</Link>
//       </Menu.Item>
//     </BaseContentSider>
//   );
//   if (defaultSelectedKeys !== '/ai/enterpriseConfig') {
//     return (
//       <BaseContent>
//         {baseContentSiderRender}
//         <BaseContentMain>{children}</BaseContentMain>
//       </BaseContent>
//     );
//   }
//   return (
//     <BaseContent>
//       <BaseContentMain>{children}</BaseContentMain>
//     </BaseContent>
//   );
// };

import React from 'react';

class AI extends React.PureComponent {
  componentDidMount() {}

  render() {
    const {children} = this.props;
    return <div className="container sysmanage-container">{children}</div>;
  }
}

export default AI;
